import React from "react";

const WhoWeAre = () => {
  return (
    <section className="relative w-full py-20 sm:py-0 px-4 sm:px-8 lg:px-24 bg-[#f7f9ff] overflow-hidden">

      {/* background glow */}
      <div className="absolute top-[-100px] left-[-100px] w-[300px] h-[300px] bg-[#f99728] opacity-20 blur-3xl rounded-full"></div>
      <div className="absolute bottom-[-120px] right-[-120px] w-[350px] h-[350px] bg-blue-400 opacity-20 blur-3xl rounded-full"></div>

      <div className="relative max-w-6xl mx-auto space-y-24">

        {/* HERO */}
        <div className="text-center">
          <div className="inline-block px-4 py-1 rounded-full bg-[#f99728]/70 backdrop-blur border text-sm text-gray-600 shadow-sm">
            Who We Are
          </div>

          <h1 className="mt-6 text-4xl sm:text-5xl font-bold text-gray-900 leading-tight">
            We Build <span className="text-[#f99728]">Digital Growth</span> That Scales Brands
          </h1>

          <p className="mt-6 text-gray-600 text-base sm:text-md max-w-5xl mx-auto leading-relaxed">
            We are a team of passionate marketers, designers, and developers committed to providing complete web solutions and digital marketing services for startups, small businesses, and growing brands.
          </p>
        </div>

        {/* FLOATING TAGS */}
        <div className="flex flex-wrap justify-center gap-3">
          {[
            "SEO Experts",
            "Web Development",
            "Paid Ads (PPC)",
            "Social Media Growth",
            "Brand Strategy",
          ].map((item, i) => (
            <span
              key={i}
              className="px-4 py-2 bg-[#f99728]/70 backdrop-blur border rounded-full text-sm text-gray-700 shadow-sm hover:scale-105 transition"
            >
              {item}
            </span>
          ))}
        </div>

        {/* MAIN SPLIT SECTION */}
        <div className="grid lg:grid-cols-2 gap-16 items-center">

          {/* LEFT CARD */}
          <div className="bg-[#f99728]/70 backdrop-blur-xl border shadow-xl rounded-3xl p-8">

            <h2 className="text-2xl font-bold text-gray-900">
              Our Approach to Digital Growth
            </h2>

            <p className="mt-4 text-gray-600 leading-relaxed">
                As a leading digital marketing and web solutions company, we believe in customized strategies tailored to your business goals.
            </p>

            <div className="mt-6">
              <h3 className="font-semibold text-gray-900 mb-3">
                Our approach includes:
              </h3>

              <div className="space-y-3 text-gray-700 text-sm sm:text-base">

                <p>✔ In-depth market research and competitor analysis</p>
                <p>✔ Keyword-focused SEO optimization</p>
                <p>✔ Data-driven campaign execution</p>
                <p>✔ Continuous performance tracking and optimization</p>

              </div>
            </div>

            


          </div>

          {/* RIGHT SERVICES */}
          <div className="space-y-6">

            <div className="bg-[#f99728]/60 backdrop-blur border rounded-2xl p-6 hover:shadow-lg transition">
              <h3 className="font-semibold text-gray-900">Website Development & Web Solutions</h3>
              <p className="text-gray-600 text-sm mt-2">
                We build modern, SEO-friendly websites that are optimized for speed, mobile responsiveness, and user experience—helping businesses convert visitors into customers.
              </p>
            </div>

            <div className="bg-[#f99728]/60 backdrop-blur border rounded-2xl p-6 hover:shadow-lg transition">
              <h3 className="font-semibold text-gray-900">Search Engine Optimization (SEO)</h3>
              <p className="text-gray-600 text-sm mt-2">
                Our advanced SEO strategies help your website rank higher on search engines like Google, driving organic traffic and long-term growth.
              </p>
            </div>

            <div className="bg-[#f99728]/60 backdrop-blur border rounded-2xl p-6 hover:shadow-lg transition">
              <h3 className="font-semibold text-gray-900">Social Media Marketing (SMM)</h3>
              <p className="text-gray-600 text-sm mt-2">
                We create engaging and data-backed social media campaigns that connect brands with their audience and increase engagement.
              </p>
            </div>

            <div className="bg-[#f99728]/60 backdrop-blur border rounded-2xl p-6 hover:shadow-lg transition">
              <h3 className="font-semibold text-gray-900">Performance Marketing & PPC</h3>
              <p className="text-gray-600 text-sm mt-2">
                Our paid advertising campaigns focus on generating leads, sales, and measurable ROI through platforms like Google Ads and social media ads.
              </p>
            </div>

          </div>
        </div>

        {/* APPROACH */}
        <div className="text-center">

          {/* <h2 className="text-3xl sm:text-4xl font-bold text-gray-900">
            Our Approach to Digital Growth
          </h2>

          <p className="mt-6 text-gray-600 max-w-3xl mx-auto text-base sm:text-lg">
            As a leading digital marketing and web solutions company, we believe in customized strategies tailored to your business goals.
          </p>

          <div className="mt-10 grid sm:grid-cols-2 gap-4 text-left max-w-3xl mx-auto text-gray-700">

            <p>→ In-depth market research and competitor analysis</p>
            <p>→ Keyword-focused SEO optimization</p>
            <p>→ Data-driven campaign execution</p>
            <p>→ Continuous performance tracking and optimization</p>

          </div> */}

          <p className="mt-10 font-semibold text-gray-900">
            We focus on delivering measurable results, including higher rankings, increased website traffic, and better conversion rates.
          </p>

        </div>

      </div>
    </section>
  );
};

export default WhoWeAre;